import { apiAction } from 'base/utils/apiHelpers';
import {
  FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST,
  FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS,
  FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE
} from 'base/actions/actionTypes';
import { GOOGLE_MAPS_STATIC_URL_ENDPOINT } from 'base/constants/endpoints';

export const fetchGoogleMapsStaticUrl = (
  queryParams = {}
) => async dispatch => {
  const endpoint = GOOGLE_MAPS_STATIC_URL_ENDPOINT;
  const result = await dispatch(
    apiAction(
      endpoint,
      'GET',
      [
        FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST,
        FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS,
        FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE
      ],
      null,
      queryParams
    )
  );
  return result;
};
